import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'

export function buildPlaceDrawerOpenedActivityEntry(
  placeName: string,
  sourcePath: string,
): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'place_drawer_opened',
    label: 'Opened place details',
    displayText: boundActivityDisplayText(`Opened details for "${placeName}"`),
    sourcePath,
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
